import { initialState } from './initialState';

export const ResetCigarUnitBoxProductionReducer = () => initialState;

export const GetCigarUnitBoxProductionReducer = {
  pending: (state) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state, action) => ({
    ...state,
    ...action.payload.data,
    loading: 'succeeded',
  }),
  rejected: (state) => ({
    ...state,
    loading: 'failed',
  }),
};
